(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["featured-product"] && !window.DesignMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.querySelector('[aria-label="Menu"]').addEventListener('click', (e) => {
  document.getElementById("header-button-cover").style.display = "inline"
  setTimeout(() => { 
    document.getElementById("header-button-cover").style.display = "none"
  }, 600);

  if (!document.getElementById('general-overlay').classList.contains('overlay-visible')) {
    document.getElementById('shopify-section-header').classList.add('header-transparent-force');
    document.getElementById('header').classList.add('header-wrapper-white-force');
    document.getElementById('logo').classList.add('header__heading-logo-white-force');
    document.getElementById('general-overlay').classList.add('overlay-visible');
    document.body.style.overflow = 'hidden'
    document.body.classList.add("sortable-handler")
    disableScroll();
  } else {
    document.getElementById('shopify-section-header').classList.remove('header-transparent-force');
    document.getElementById('header').classList.remove('header-wrapper-white-force');
    document.getElementById('logo').classList.remove('header__heading-logo-white-force');
    document.getElementById('general-overlay').classList.remove('overlay-visible');
    document.body.style.overflow = 'scroll'
    document.body.classList.remove("sortable-handler")
    enableScroll();
  }
})

class StickyHeader extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.header = document.getElementById('shopify-section-header');
        this.headerBounds = {};
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
    }

    disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) 
            return;
        

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (!this.preventReveal) {
                requestAnimationFrame(this.reveal.bind(this));
            } else {
                window.clearTimeout(this.isScrolling);

                this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                }, 66);

                requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
    }

    hide() {
        this.header.classList.add('shopify-section-header-hidden');
        this.header.classList.remove('header-transparent');
        this.closeMenuDisclosure();
        this.closeSearchModal();
    }

    reveal() {
        this.header.classList.add('shopify-section-header-sticky', 'animate', 'header-overlay', 'background-color-transition');
        this.header.classList.remove('shopify-section-header-hidden', 'header-transparent');
        document.getElementById('header').classList.add('header-wrapper-white');
        document.getElementById('logo').classList.add('header__heading-logo-white');
    }

    reset() {
        this.header.classList.add('header-transparent');
        this.header.classList.remove('shopify-section-header-hidden', 'header-overlay');
        if (window.location.pathname != '/') {
          document.getElementById('header').classList.remove('header-wrapper-white');
          document.getElementById('logo').classList.remove('header__heading-logo-white');
        }
    }

    closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
        this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        this.searchModal.close(false);
    }
}

customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !window.DesignMode) return;
  try {
    

const headerHeight = document.getElementById("header").offsetHeight;
const imageBanner = document.getElementsByClassName("firstBanner")[0];
imageBanner.style.marginTop = `-${headerHeight}px`;

const announcementBarHeight = document.getElementById("shopify-section-announcement-bar").offsetHeight;
imageBanner.style.height = `${window.innerHeight - announcementBarHeight}px`;


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  waitForElm(".rc-widget").then((elem) => {
    const labels = document.getElementsByClassName("rc-radio__label")
    labels[0].innerText = labels[0].innerText.slice(0, labels[0].innerText.indexOf("purchase") + 8)
    labels[1].innerText = labels[1].innerText.slice(0, labels[1].innerText.indexOf("%") + 1)

    labels[0].parentElement.style.borderRadius = "50px"
    labels[1].parentElement.style.borderRadius = "25px 25px 0px 0px"
  })

  waitForElm(".yotpo-stars").then((elem) => {
    if (!document.getElementsByClassName("yotpo-sum-reviews").length) {
      document.getElementsByClassName("yotpo-display-wrapper")[1].innerHTML = '<h3 style="text-align: center">No Reviews Yet</h3>'
      document.getElementsByClassName("yotpo-display-wrapper")[1].style.paddingTop = '10px'
    }
  })

  waitForElm(".yotpo-thank-you").then((elem) => {
    elem.innerHTML = "Thank you for posting a review! Your review will appear shortly."
  })

  waitForElm(".yotpo-submit").then((elem) => {
    elem.classList.remove("primary-color-btn")
  })

  waitForElm(".write-first-review-button").then((elem) => {
    elem.innerText = "write us a review"
    elem.addEventListener("click", removeClickedElement);
  })

  waitForElm(".write-review").then((elem) => {
    var labels = Array.from(elem.getElementsByClassName("y-label"))
    labels.splice(0, 1);
    labels.splice(3, 1);
    labels.forEach((label) => {
      const index = label.innerHTML.indexOf(':')
      label.innerHTML = label.innerHTML.substring(0, index + 1) + "<br>" + label.innerHTML.substring(index + 1, label.innerHTML.length)
    });
    labels[3].innerHTML = labels[3].innerHTML.replace("Use your name", "Name")
  })

  waitForElm(".yotpo-nav-primary").then((elem) => {
    elem.children[0].style.display = "none"
  })

  waitForElm(".yotpo-nav-dropdown-category").then((elem) => {
    elem.innerHTML = "write us a review"
    elem.addEventListener("click", removeClickedElement);
  })

  function removeClickedElement(e) {
    e.target.parentElement.parentElement.remove()
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

})();
